<template>
    <el-popover placement="bottom-start" width="310" trigger="click" :value="visible" @show="visible = true">
        <el-form :model="filterForm" ref="filterForm">
            <el-form-item size="small" prop="dateRange" label="Date Range">
                <el-date-picker
                v-model="filterForm.dateRange"
                format="MM/dd/yyyy"
                value-format="MM/dd/yyyy"
                type="daterange"
                range-separator="-"
                start-placeholder="Start date"
                end-placeholder="End date"
                style="width:100%;">
                </el-date-picker>
            </el-form-item>

            <el-form-item size="small" prop="brandName" label="Brand" >
                <el-select v-model="filterForm.brandName" placeholder="Brand" style="width:100%;">
                    <el-option v-for="(brandName, index) in brandRecords" :key="index" :label="brandName" :value="brandName"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item size="small" prop="currentUser" label="Uploaded By" >
                <el-select v-model="filterForm.currentUser" placeholder="Uploaded By" style="width:100%;">
                    <el-option v-for="(user, index) in userRecords" :key="index" :label="user" :value="user"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item size="small" prop="invoiceType" label="Invoice Type" >
                <el-select v-model="filterForm.invoiceType" placeholder="Audited By" style="width:100%;">
                    <el-option v-for="(invoiceType, index) in ['MFN','BULK','Template']" :key="index" :label="invoiceType" :value="invoiceType"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item size="small" prop="status" label="Status" >
                <el-select v-model="filterForm.status" placeholder="Segment" style="width:100%;">
                    <el-option v-for="(status, index) in statusRecords" :key="index" :label="status.text" :value="status.value"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-button size="small" type="danger" plain @click="handleClearFilter">Clear</el-button>
                <div style="float: right;">
                     <el-button size="small" type="info" plain @click="visible = false">Cancel</el-button>
                    <el-button size="small" type="primary" @click="handleFilter" style="width:8em">Filter</el-button>
                </div>
            </el-form-item>
        </el-form>
        <el-button size="small" type="primary" slot="reference" icon="mdi mdi-filter-menu"> Filter</el-button>
    </el-popover>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import * as type from '../../../store/types';
import { bus } from '@/main';
export default {
    data(){
        return {
            visible: false,
            filterForm: {
				dateRange: '',
				brandName: '',
                invoiceType: '',
                currentUser: '',
                status: '',
			}
        }
    },
    computed: {
        ...mapGetters({
            brandRecords: 'uploadhistory/brands',
            userRecords: 'uploadhistory/users',
            statusRecords: 'uploadhistory/status'
        })
    },
    created(){
        this.loadBrands();
        this.loadUsers();
        this.loadStatus();

        bus.$on('clearUploadHistoryFilter', this.handleClearFilter)
    },
    methods: {
        ...mapActions({
            loadBrands: `uploadhistory/${type.GET_BRAND_RECORDS}`,
            loadUsers: `uploadhistory/${type.GET_USER_RECORDS}`,
            loadStatus: `uploadhistory/${type.GET_STATUS_RECORDS}`,
            loadUploadHistory: `uploadhistory/${type.GET_UPLOAD_HISTORY}`,
        }),
        handleFilter(){
            let startDate = this.filterForm.dateRange[0]
			let endDate =  this.filterForm.dateRange[1]
            let {brandName, invoiceType, currentUser, status  } = this.filterForm;

            this.loadUploadHistory({
                startDate,
                endDate,
                brandName,
                invoiceType,
                currentUser,
                status
            })
            this.visible = false;
        },
        handleClearFilter(){
            this.$refs.filterForm.resetFields();
        }
    }
}
</script>